import React from "react";
import Divider from "../Divider/Divider";

type HeaderProps = {
  className?: string;
  header?: string;
  header2?: string;
  boldText?: string;
  info?: string;
  info2?: string;
  info3?: string;
  inverted?: boolean;
  infoHtml?: boolean;
  background?: string;
  white?: boolean;
  coloredTop?: string;
  marginTop?: number;
  marginBottom?: number;
};

const Header: React.FunctionComponent<HeaderProps> = ({
  className = "",
  header,
  header2,
  boldText,
  info,
  info2,
  info3,
  inverted,
  infoHtml,
  background,
  white,
  coloredTop,
  marginTop,
  marginBottom,
}): React.ReactElement => {
  const reduceMargin = {
    paddingTop: marginTop + "px",
    paddingBottom: marginBottom + "px",
  };
  const backgroundClass = background === "grey" ? "mainBackgroundGrey" : "";
  const infoToDisplay =
    info &&
    (infoHtml ? (
      <div
        className="headerComponent__info"
        dangerouslySetInnerHTML={{ __html: info }}
      />
    ) : (
      <p className="headerComponent__info">{info}</p>
    ));

  return (
    <div
      style={reduceMargin}
      className={`headerComponent ${className} ${backgroundClass} ${
        white ? "white" : ""
      }`}
    >
      <div className="desktop-container">
        {coloredTop && (
          <h3 className="headerComponent__coloredTop">{coloredTop}</h3>
        )}

        {header && (
          <h4
            className="headerComponent__header"
            dangerouslySetInnerHTML={{ __html: header }}
          />
        )}

        {header2 && (
          <h2 className="headerComponent__header headerComponent__header2">
            {header2}
          </h2>
        )}

        {inverted && <Divider />}
        {boldText && <p className="headerComponent__bold">{boldText}</p>}
        {info && infoToDisplay}
        {info2 && (
          <h5
            className={`headerComponent__info headerComponent__info2 ${backgroundClass}`}
          >
            {info2}
          </h5>
        )}
        {info3 && <p className="headerComponent__info">{info3}</p>}
      </div>
    </div>
  );
};

export default Header;
